import { render, staticRenderFns } from "./chat-addbook.vue?vue&type=template&id=02bdcce6&scoped=true"
import script from "./chat-addbook.vue?vue&type=script&lang=js"
export * from "./chat-addbook.vue?vue&type=script&lang=js"
import style0 from "./chat-addbook.vue?vue&type=style&index=0&id=02bdcce6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bdcce6",
  null
  
)

export default component.exports